export default __webpack_public_path__ + "static/media/hiw-b.c3a41a3f.svg";